@if (hasActiveUploads) {
  <div class="upload-indicator-container">
    <div class="upload-indicator-panel" (click)="openUploadDialog()">
      <div class="panel-header">
        <div class="header-title-wrap">
          <span class="header-title">{{ headerTitle }}</span>
        </div>
        <div class="header-actions">
          <button type="button" class="header-icon-btn" (click)="toggleCollapsed($event)" [title]="isCollapsed ? 'Expand' : 'Collapse'">
            <i class="pi" [ngClass]="isCollapsed ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </button>
          <button type="button" class="header-icon-btn" (click)="dismissIndicator($event)" title="Close">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
      @if (!isCollapsed) {
        <div class="panel-body">
          <div class="upload-items-scroll">
            @for (folder of folderUploads; track trackFolder($index, folder)) {
              <div class="upload-row folder-row">
                <div class="row-left">
                  <i class="pi pi-folder row-icon"></i>
                  <div class="row-text">
                    <div class="row-title">{{ folder.folderName }}</div>
                    <div class="row-subtitle">{{ getFolderStatusText(folder) }}</div>
                  </div>
                </div>
                <div class="row-right">
                  @if (canPauseFolder(folder)) {
                    <button
                      type="button"
                      class="row-action-btn"
                      (click)="pauseFolderUpload($event, folder)"
                      [class.is-loading]="isControlActionLoading('folder:pause:' + folder.folderName)"
                      [disabled]="isControlActionLoading('folder:pause:' + folder.folderName)"
                      title="Pause">
                      @if (!isControlActionLoading('folder:pause:' + folder.folderName)) {
                        <i class="pi pi-pause"></i>
                      }
                      @if (isControlActionLoading('folder:pause:' + folder.folderName)) {
                        <i class="pi pi-spinner pi-spin"></i>
                      }
                    </button>
                  }
                  @if (canResumeFolder(folder)) {
                    <button
                      type="button"
                      class="row-action-btn"
                      (click)="resumeFolderUpload($event, folder)"
                      [class.is-loading]="isControlActionLoading('folder:resume:' + folder.folderName)"
                      [disabled]="isControlActionLoading('folder:resume:' + folder.folderName)"
                      title="Resume">
                      @if (!isControlActionLoading('folder:resume:' + folder.folderName)) {
                        <i class="pi pi-play"></i>
                      }
                      @if (isControlActionLoading('folder:resume:' + folder.folderName)) {
                        <i class="pi pi-spinner pi-spin"></i>
                      }
                    </button>
                  }
                  @if (showDisabledResumeFolder(folder)) {
                    <button
                      type="button"
                      class="row-action-btn disabled"
                      title="Re-select file/folder in Upload Media to enable resume"
                      disabled>
                      <i class="pi pi-play"></i>
                    </button>
                  }
                  @if (isFolderCompleted(folder)) {
                    <i class="pi pi-check-circle status-icon completed"></i>
                  }
                  @if (!isFolderCompleted(folder) && isFolderFailed(folder)) {
                    <i class="pi pi-times-circle status-icon failed"></i>
                  }
                  @if (!isFolderCompleted(folder) && !isFolderFailed(folder) && isFolderPaused(folder)) {
                    <i class="pi pi-pause-circle status-icon paused"></i>
                  }
                  @if (!isFolderCompleted(folder) && !isFolderFailed(folder) && !isFolderPaused(folder)) {
                    <i class="pi pi-spinner pi-spin status-icon uploading"></i>
                  }
                </div>
              </div>
            }
            @for (upload of standaloneFiles; track trackFile($index, upload)) {
              <div class="upload-row file-row">
                <div class="row-left">
                  <i class="pi pi-file row-icon"></i>
                  <div class="row-text">
                    <div class="row-title" [title]="upload.file.name">{{ upload.file.name }}</div>
                    <div class="row-subtitle">{{ getFileStatusText(upload) }}</div>
                  </div>
                </div>
                <div class="row-right">
                  @if (canPauseFile(upload)) {
                    <button
                      type="button"
                      class="row-action-btn"
                      (click)="pauseFileUpload($event, upload)"
                      [class.is-loading]="isControlActionLoading('file:pause:' + upload.fileId)"
                      [disabled]="isControlActionLoading('file:pause:' + upload.fileId)"
                      title="Pause">
                      @if (!isControlActionLoading('file:pause:' + upload.fileId)) {
                        <i class="pi pi-pause"></i>
                      }
                      @if (isControlActionLoading('file:pause:' + upload.fileId)) {
                        <i class="pi pi-spinner pi-spin"></i>
                      }
                    </button>
                  }
                  @if (canResumeFile(upload)) {
                    <button
                      type="button"
                      class="row-action-btn"
                      (click)="resumeFileUpload($event, upload)"
                      [class.is-loading]="isControlActionLoading('file:resume:' + upload.fileId)"
                      [disabled]="isControlActionLoading('file:resume:' + upload.fileId)"
                      title="Resume">
                      @if (!isControlActionLoading('file:resume:' + upload.fileId)) {
                        <i class="pi pi-play"></i>
                      }
                      @if (isControlActionLoading('file:resume:' + upload.fileId)) {
                        <i class="pi pi-spinner pi-spin"></i>
                      }
                    </button>
                  }
                  @if (showDisabledResumeFile(upload)) {
                    <button
                      type="button"
                      class="row-action-btn disabled"
                      title="Re-select file/folder in Upload Media to enable resume"
                      disabled>
                      <i class="pi pi-play"></i>
                    </button>
                  }
                  @if (isFileCompleted(upload)) {
                    <i class="pi pi-check-circle status-icon completed"></i>
                  }
                  @if (!isFileCompleted(upload) && isFileFailed(upload)) {
                    <i class="pi pi-times-circle status-icon failed"></i>
                  }
                  @if (!isFileCompleted(upload) && !isFileFailed(upload) && isFilePaused(upload)) {
                    <i class="pi pi-pause-circle status-icon paused"></i>
                  }
                  @if (!isFileCompleted(upload) && !isFileFailed(upload) && !isFilePaused(upload)) {
                    <i class="pi pi-spinner pi-spin status-icon uploading"></i>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
